import React from 'react';
import { useCallback, useEffect, useState } from 'react';
import CustomerBrowser from './CustomerBrowser';
import CustomerProfile from './CustomerProfile';
import * as CustomerApi from '../../Services/CustomerApi';
import * as SubscriptionApi from '../../Services/SubscriptionApi';
import { useParams } from 'react-router-dom';
// import config from '../../config/config';
import { Container, Tabs, Tab, AppBar, Paper, Typography } from '@mui/material';
import { TabPanel } from 'Components/Styled';

import Ledger from './Loyalty/Ledger';
import MicroExperienceDashboard from './MicroExperience';
import { siteTheme } from '../../Components/SiteTheme';
import config from '../../config/config';
import SubscriptionHistory from './Subscription/SubscriptionHistory';
import PaymentHistory from './Subscription/PaymentHistory';
import { TagsContextProvider } from 'Modules/Components/TagsContext';
import UserFormReponses from './UserFormResponse';

const tabs = ['Details', 'Events', 'Points', 'Payments', 'WonderPass', 'Engage','User Form Reponses'];

function CustomerModule(props) {
    const [customer, setCustomer] = useState();
    const [loyaltyBalance, setLoyaltyBalance] = useState([]);
    const [activeSubs, setActiveSubs] = useState();
    const [subscriptionTypes, setSubscriptionTypes] = useState([]);
    const [subscriptionTiers, setSubscriptionTiers] = useState([]);
    const [cards, setCards] = useState([]);
    const { customerId } = useParams();

    const fetchCustomer = useCallback(async () => {
        const profile = await CustomerApi.getCustomerProfile(customerId);
        setCustomer((prevCustomer)=>({
            ...prevCustomer,profile
        }));
    }, [customerId]);

    const fetchLoyaltyLedger = useCallback(async () => {
        const loyaltyLedger = await CustomerApi.getCustomerLoyaltyLedger(customerId);
        setCustomer((prevCustomer)=>({
            ...prevCustomer,loyaltyLedger
        }));
    }, [customerId]);

    const fetchMilestones = useCallback(async () => {
        const milestones = await CustomerApi.getCustomerMilestones(customerId);
        setCustomer((prevCustomer)=>({
            ...prevCustomer,milestones
        }));
    }, [customerId]);

    const fetchInternalProfile = useCallback(async () => {
        const internalProfile = await CustomerApi.getCustomerInternalProfile(customerId);
        setCustomer((prevCustomer)=>({
            ...prevCustomer,internalProfile
        }));
    }, [customerId]);

    const fetchCustomerPoints = useCallback(async () => {
        const loyaltyBalance = await CustomerApi.getCustomerLoyaltyBalance(customerId);
        setLoyaltyBalance(loyaltyBalance);
    }, [customerId]);


    const fetchCustomerSubscription = useCallback(async () => {
        const activeSubs = await CustomerApi.getCustomerActiveSubscription(customerId);
        if(activeSubs?.id){
            setActiveSubs(activeSubs);
        }else{
            setActiveSubs(null);
        }
    }, [customerId]);

    const updateCustomer = useCallback(async () => {
        try {
            fetchCustomer();
            fetchLoyaltyLedger();
            fetchMilestones();
            fetchInternalProfile();
            fetchCustomerPoints();
            fetchCustomerSubscription();
        } catch (error) {
            console.log("Error fetching customer details",error)
        }
      
    }, [fetchCustomer, fetchLoyaltyLedger, fetchMilestones, 
        fetchInternalProfile, fetchCustomerPoints, fetchCustomerSubscription]);

    async function loyaltyPointsUpdated() {
        if (customerId) {
            const loyaltyBalance = await CustomerApi.getCustomerLoyaltyBalance(customerId);
            setLoyaltyBalance(loyaltyBalance);
        }
    }

    const fetchSubscriptionTypes = useCallback(async () => {
        const data = await SubscriptionApi.getSubscriptionTypes();
        setSubscriptionTypes(data || []);
    }, []);

    const fetchSubscriptionTiers = useCallback(async () => {
        const data = await SubscriptionApi.getSubscriptionTiers();
        setSubscriptionTiers(data || []);
    }, []);

    const fetchCards = useCallback(async () => {
        const data = await CustomerApi.getCustomerCards(customerId);
        setCards(data || []);
    }, [customerId]);

    const addSubscription = async (data) => {
        if (data) {
            await SubscriptionApi.saveSubscription(data);
            await updateCustomer();
            await fetchCards();
        }
    };

    const addSubscriptionPayment = async (data) => {
        if (data) {
            const test = await SubscriptionApi.saveSubscriptionPayment(data);
            console.log(test);
            await updateCustomer();
            await fetchCards();
        }
    };

    const editSubscriptionPayment = async (data) => {
        if (data) {
            const test = await SubscriptionApi.editSubscriptionPayment(data);
            console.log(test);
            await updateCustomer();
            await fetchCards();
        }
    };

    const editSubscriptionNote = async (data) => {
        if (data) {
            await SubscriptionApi.editSubscriptionNote(data);
            await updateCustomer();
            await fetchCards();
        }
    };

    const cancelSubscription = async (data) => {
        if (data) {
            await SubscriptionApi.cancelSubscription(data);
            await updateCustomer();
        }
    };

    const addCard = async (data) => {
        if (data) {
            await CustomerApi.addCustomerCard(data);
            await fetchCards();
        }
    };

    const removeCard = async (data) => {
        if (data) {
            await CustomerApi.deleteCustomerCard(data);
            await fetchCards();
        }
    };

    const changeSubscription = async (data) => {
        if (data) {
            await SubscriptionApi.changeSubscription(data);
            await updateCustomer();
            await fetchCards();
        }
    }

    const revertSubscription = async (data) => {
        if(data){
            await SubscriptionApi.revertSubscription(data);
            await updateCustomer();
            await fetchCards();
        }
    }

    useEffect(() => {
        fetchSubscriptionTypes();
    }, [fetchSubscriptionTypes]);

    useEffect(() => {
        fetchSubscriptionTiers();
    }, [fetchSubscriptionTiers]);

    useEffect(() => {
        fetchCards();
    }, [fetchCards]);

    useEffect(() => {
        setCustomer();
        if (customerId) {
            updateCustomer();
        }
    }, [customerId, updateCustomer]);

    const [selectedTab, setSelectedTab] = React.useState(0);

    const handleTabChange = (event, newValue) => {
        if (newValue === 1) {
            window.open(config.hqURL + '/customers/' + customer.profile.hqCustomerId, '_blank');
        }
        setSelectedTab(newValue);
    };

    return (
        <>
            <CustomerBrowser activeCustomerId={customerId} />
            {customer?.profile && customerId ? (
                <div className="ModulePanel--wrapper CustomerData--wrapper">
                    <Container style={{ backgroundColor: '#fff' }}>
                        <Paper elevation={0}>
                            <div className="CustomerDataTabs" style={{ padding: '11px 12px 0px' }}>
                                <AppBar position="static">
                                    <Tabs value={selectedTab} onChange={handleTabChange}>
                                        {tabs.map((tab, index) => (
                                            <Tab key={index} style={{ textTransform: 'capitalize' }} label={tab} />
                                        ))}
                                    </Tabs>
                                </AppBar>
                                <TabPanel value={selectedTab} index={0}>
                                <TagsContextProvider>
                                    <CustomerProfile
                                        customer={customer}
                                        latestSubscription={activeSubs}
                                        loyaltyBalance={loyaltyBalance}
                                        subscriptionTypes={subscriptionTypes}
                                        subscriptionTiers={subscriptionTiers}
                                        cards={cards}
                                        addSubscription={addSubscription}
                                        addSubscriptionPayment={addSubscriptionPayment}
                                        editSubscriptionPayment={editSubscriptionPayment}
                                        cancelSubscription={cancelSubscription}
                                        editSubscriptionNote={editSubscriptionNote}
                                        addCard={addCard}
                                        removeCard={removeCard}
                                        changeSubscription={changeSubscription}
                                        revertSubscription={revertSubscription}
                                    />
                                </TagsContextProvider>
                                </TabPanel>
                                <TabPanel value={selectedTab} index={1}>
                                    <div className="CustomerProfile--Value">
                                        <Typography
                                            variant="h3"
                                            style={{ fontWeight: '500', fontFamily: 'gilroy-regular' }}
                                            p={siteTheme.spacing(8)}
                                        >
                                            To view the customer’s bookings, select the “Events” heading above. This
                                            will open the customer’s HQ profile in a new tab.
                                            <br />
                                            If it opens up blank, the customer hasn’t yet booked anything with us.
                                        </Typography>
                                    </div>
                                </TabPanel>
                                <TabPanel value={selectedTab} index={2}>
                                    <Ledger
                                        customer={customer}
                                        loyaltyBalance={loyaltyBalance}
                                        loyaltyPointsUpdated={loyaltyPointsUpdated}
                                    />
                                </TabPanel>
                                <TabPanel value={selectedTab} index={3}>
                                    <PaymentHistory profile={customer?.profile} cards={cards} />
                                </TabPanel>
                                <TabPanel value={selectedTab} index={4}>
                                    <SubscriptionHistory profile={customer?.profile} />
                                </TabPanel>
                                <TabPanel value={selectedTab} index={5}>
                                        <MicroExperienceDashboard customer={customer} />
                                </TabPanel>
                                <TabPanel value={selectedTab} index={6}>
                                        <UserFormReponses customer={customer} customerId={customerId} />
                                </TabPanel>
                            </div>
                        </Paper>
                    </Container>
                </div>
            ) : customerId ? (
                <div className=" MainPanel--wrapper ModulePanel--wrapper CustomerData--wrapper">
                    <Container style={{ backgroundColor: 'white' }}>Loading Customer...</Container>
                </div>
            ) : (
                <div className=" MainPanel--wrapper ModulePanel--wrapper CustomerData--wrapper">
                    <Container style={{ backgroundColor: 'white' }}></Container>
                </div>
            )}
        </>
    );
}

export default CustomerModule;
